import { render, staticRenderFns } from "./PlataformaListado.vue?vue&type=template&id=0a3c3662"
import script from "./PlataformaListado.vue?vue&type=script&lang=js"
export * from "./PlataformaListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports